import { PasswordResetPageContent } from '@pages/Anonymous/PasswordResetPage/components/Content';
import { PageProvider } from '@pages/Anonymous/PasswordResetPage/providers/PageProvider';

export const PasswordResetPage = () => {
  return (
    <PageProvider>
      <PasswordResetPageContent />
    </PageProvider>
  );
};
